module.exports = __webpack_public_path__ + "img/nissan-Used.bea7ed4c.png";